import React, {useContext, useState} from "react";
import Popup from "../../components/Popup/Popup";

import "./Accounts.scss";
import PopupContext from "../../components/Popup/PopupContext";

const ConfirmDeleteDialog = (props) => {
  const {setPopupContent} = useContext(PopupContext);
  const [userInput, setUserInput] = useState("");
  const [isCorrect, setCorrect] = useState(false);

  const account = props.account;
  const accountName = account.type === "free" ? account.description : "#" + ("00000" + account.id).slice(-5);

  const checkUserInput = (e) => {
    setUserInput(e.target.value);
    if (e.target.value === accountName) {
      setCorrect(true);
    } else {
      setCorrect(false)
    }
  }

  return (
    <Popup
      title={'Webseite löschen'}
      confirmButton={"Löschen"}
      cancelButton={"Abbrechen"}
      onConfirm={() => props.onClose(true)}
      onCancel={() => props.onClose(false)}
      style={{width:500}}
      disableConfirm={!isCorrect}
    >
      <div className={'delete-confirm'}>
        <div style={{fontSize: 16, marginBottom: 20}}>
          Soll die Webseite tatsächlich gelöscht werden?<br/>Bitte bestätige die Löschung indem du den Namen der Webseite
          <div className={'delete-confirm-account'}>
            {accountName}
          </div>
          in das Textfeld einträgst.
        </div>
        <input autofocus onChange={checkUserInput} value={userInput} onKeyDown={(e) => e.key === 'Enter' && isCorrect && (props.onClose(true) || setPopupContent(""))} placeholder={'Hier bitte den Namen eintragen'}/>
      </div>
    </Popup>

  );
}

export default ConfirmDeleteDialog;